module.exports = __webpack_public_path__ + "static/media/DSC_6871-Edit.2152f205.jpg";